<p>Flowchart imported</p>
<mat-accordion displayMode="flat" multi togglePosition="before">
@for (visit of lstVisite; track $index) {
<mat-expansion-panel class="flowchart-panel">
    <mat-expansion-panel-header class="flowchart-panel-header">
        <mat-panel-title class="flowchart-visit-title">
            {{visit.num}} - {{visit.code}}
            <span class="flowchart-visit-title-description">{{visit.label}}</span>
        </mat-panel-title>
        <mat-panel-description>
            {{visit.forms.length}} Formulaire(s)
        </mat-panel-description>

    </mat-expansion-panel-header>

    <div class="form-list">
        @for (form of visit.forms; track $index) {
        <div class="form-item">
            <strong>Code :</strong> {{ form.code }}
            @if (form.labelCode) {<span> - Label : {{ form.labelCode }}</span>}
            @if (form.epro) {<span style="color: blueviolet;font-weight: bold; margin-left: 15px;">ePro</span>}
            @if (form.metaData['HIDEABLE'] != null) {<span style="color: goldenrod;font-weight: bold; margin-left: 15px;">Condition d'apparition {{form.metaData['HIDEABLE']}}</span>}
            <mat-expansion-panel togglePosition="before" class="form-item-panel">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ form.fields.length }} champs définis
                    </mat-panel-title>
                </mat-expansion-panel-header>
                
                @for (myfield of form.fields; track $index) {
                    <div [ngClass]="{
                            'field-type-title':myfield.type == 'title',
                            'field-type-repeated':myfield.metaData['GROUPE_REPEATED']
                            }"><span class="field-num">({{ myfield.orderInForm }})</span> {{ myfield.labelCode }}
                    @if (myfield.type == 'qnumber' || myfield.type == 'qdate' || myfield.type == 'qtext') {
                        <input type="text">
                    } @else if (myfield.type == 'list' || myfield.type == 'qmulti') {
                        <div>Liste {{myfield.metaData['LIST_CODE']}}</div>
                        @for (lstValue of lstFormatMap.get((myfield.metaData['LIST_CODE']??'UNKONW.').slice(0,-1))?.values; track $index) {
                            <mat-checkbox>{{ lstValue.i18nCodeLabel }}</mat-checkbox>&nbsp; ({{ lstValue.value }} -- decode SAS: {{ lstValue.sasLabel }})
                        }
                    } @else if (myfield.type == 'qlist') {
                        <div>Liste {{myfield.metaData['LIST_CODE']}}</div>
                        <mat-form-field style="width: 100%;">
                        <mat-label>Please select an option</mat-label>
                        <mat-select>
                        @for (lstValue of lstFormatMap.get((myfield.metaData['LIST_CODE']??'UNKONW.').slice(0,-1))?.values; track $index) {
                            <mat-option value="{{ lstValue.value }}">{{ lstValue.i18nCodeLabel }}&nbsp; ({{ lstValue.value }} -- decode SAS: {{ lstValue.sasLabel }})</mat-option>
                        }
                        </mat-select>
                        </mat-form-field>
                    }
                    @if (myfield.variableName && myfield.type != 'title') {
                        <div class="field-legend">Alimente la variable {{ myfield.variableName }} ({{ myfield.type }})</div>
                    } @else {
                        <div class="field-legend">Sert pour la présentation (type {{ myfield.type }})</div>
                    }
                    @for (metadata of getMetaDataEntries(myfield.metaData); track $index) {
                        <div style="padding-left: 60px;font-size: smaller;">Metadata : {{ metadata[0] }} : {{ metadata[1] }}</div>
                    }
                    </div>
                } @empty {
                    <p>Aucun champs dans ce formulaire</p>
                }
                </mat-expansion-panel>

        </div>
        }
        @if (visit.forms.length === 0) {
        <p class="no-forms-message">
            Aucun formulaire associé à cette visite.
        </p>
        }
    </div>

</mat-expansion-panel>
}
</mat-accordion>

<div>&nbsp;</div>